// Resuelve qué campos quedan ocultos por las reglas de visibilidad de un
// formulario. Flujo propio para el formulario público: a diferencia del
// antiguo `computeHiddenFields` de `formRulesEngine.js`, un valor que
// ninguna regla menciona explícitamente no oculta nada — solo las reglas
// cuya condición coincide con el valor actual pueden ocultar o mostrar un
// campo. Espejo del servicio Ruby `Forms::FieldVisibility`.

import { RULE_TYPES, OPERATORS, ACTIONS } from './formRulesEngine';

const conditionMet = (rule, values) => {
  const sourceValue = values[rule.source_field];
  switch (rule.operator) {
    case OPERATORS.EQUALS:
      return sourceValue === rule.value;
    case OPERATORS.NOT_EQUALS:
      return sourceValue !== rule.value;
    case OPERATORS.ONE_OF:
      return Array.isArray(rule.value) && rule.value.includes(sourceValue);
    default:
      return false;
  }
};

// Un valor sin ninguna regla configurada para él no restringe nada (queda
// visible por defecto). Cuando sí hay al menos una regla cuya condición
// coincide con el valor actual, `hide` tiene precedencia sobre `show`.
const groupVisible = (sourceRules, values) => {
  const matched = sourceRules.filter(rule => conditionMet(rule, values));
  if (!matched.length) return true;
  return !matched.some(rule => rule.action === ACTIONS.HIDE);
};

const groupBySourceField = rules => {
  const groups = {};
  rules.forEach(rule => {
    const key = rule.source_field;
    groups[key] = groups[key] || [];
    groups[key].push(rule);
  });
  return Object.values(groups);
};

const isFieldVisible = (fieldName, visibilityRules, values) => {
  const relevant = visibilityRules.filter(rule =>
    (rule.target_fields || []).includes(fieldName)
  );
  if (!relevant.length) return true;

  return groupBySourceField(relevant).every(sourceRules =>
    groupVisible(sourceRules, values)
  );
};

export const computeHiddenFields = (rules = [], values = {}) => {
  const visibilityRules = rules.filter(
    rule => rule.type === RULE_TYPES.VISIBILITY
  );
  const targets = new Set();
  visibilityRules.forEach(rule => {
    (rule.target_fields || []).forEach(field => targets.add(field));
  });

  return [...targets].filter(
    field => !isFieldVisible(field, visibilityRules, values)
  );
};
